<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-12 col-lg-9 mx-auto">
        <p>
          Através de uma relação de multicálculos integrados com a Tokio Marine o corretor poderá impulsionar suas vendas
          por intermédio da adesão as API existentes.
        </p>
      </div>
    </div>
    <!-- passo 1 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>1° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Acesse o Portal Parceiros e clique no menu "Eu Corretor"!
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-vendas-1.png" alt="">
      </div>
    </div>
    <!-- passo 2 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>2° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Na sessão de "Integrações e Serviços" clique em "Adesão Multicalculo".
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-vendas-2.png" alt="">
      </div>
    </div>
    <!-- passo 3 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>3° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Selecione o produto desejado e o Multicalculo escolhido e clique em “Aderir”.
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-vendas-3.png" alt="">
      </div>
    </div>
    <!-- passo 4 -->
    <div class="row passos mt-5 mb-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>4° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Será apresentada uma mensagem de confirmação e o corretor receberá via e-mail a aprovação ou recusa da solicitação.
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-vendas-5.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  }
};
</script>
